export enum HorizontalDrawingParts {
    borehole,
    casing,
    cement,
    shoe,
    collar,
    basket,
    packer
}